import {
    ADMIN_LOGGED_IN,
    ADMIN_LOGIN, API_CALL_FAILED, CREATE_CUSTOMER, CREATE_LANGUAGE, CREATED_CUSTOMER, CREATED_LANGUAGE, GET_CUSTOMER,
    ADMIN_LOGOUT,
    GET_CUSTOMERS,
    GET_LANGUAGE,
    GET_LANGUAGES,
    GET_PREDEFINED_TEXTS,
    GET_PROPERTY_DEFINITIONS,
    PRIVATE_CORE_LOGGED_IN, PRIVATE_CORE_LOGIN, PRIVATE_CORE_LOGOUT,
    RETRIEVED_CUSTOMER,
    RETRIEVED_CUSTOMERS, RETRIEVED_LANGUAGE, RETRIEVED_LANGUAGES, RETRIEVED_PREDEFINED_TEXTS,
    RETRIEVED_PROPERTY_DEFINITIONS, SAVE_CUSTOMER, SAVE_LANGUAGE,
    SAVE_PREDEFINED_TEXT, SAVE_TRANSLATION_KEYS, SAVED_CUSTOMER, SAVED_LANGUAGE, SAVED_PREDEFINED_TEXT,
    SAVED_TRANSLATION_KEYS, DOWNLOADED_TRANSLATIONS, DOWNLOAD_TRANSLATIONS
} from "./action-types";
import {CREATE_MODE, DELETE_MODE, EDIT_MODE} from "../components/constants";

export const initialState = {
    customers: [],
    pendingCalls: 0,
    privateCoreJwt : {},
    propertyDefinitions: {}
};

function addLastAction(state, action) {
    console.log(state.pendingCalls + "calls outstanding...");
    return { ...state, lastAction: action };
}

const actionToState = (state, action) => {
    switch (action.type) {
        case ADMIN_LOGIN:
            return { ...state, pendingCalls: state.pendingCalls + 1 };
            
        case ADMIN_LOGOUT:
            const loggedOutState = {
                ...state,
                loggedIn: false,
                privateCoreJwt: initialState.privateCoreJwt
            };
            delete loggedOutState.jwt;
            delete loggedOutState.user;
            if(!action.payload.displayError)
                delete loggedOutState.lastError;
            return loggedOutState;
            
        case ADMIN_LOGGED_IN:
            return { ...state, pendingCalls: state.pendingCalls - 1, loggedIn: true, lastError : undefined, jwt: action.payload.jwt, user: action.payload.adminUser };

        case GET_CUSTOMERS:
            return { ...state, pendingCalls: state.pendingCalls + 1 };

        case RETRIEVED_CUSTOMERS:
            return { ...state, pendingCalls: state.pendingCalls - 1, customers: action.payload, currentCustomer: undefined };

        case GET_CUSTOMER:
            return { ...state, pendingCalls: state.pendingCalls + 1 };

        case RETRIEVED_CUSTOMER:
            return { ...state, pendingCalls: state.pendingCalls - 1, currentCustomer: action.payload };

        case SAVE_CUSTOMER:
            return { ...state, pendingCalls: state.pendingCalls + 1 };

        case SAVED_CUSTOMER:
            return { ...state, pendingCalls: state.pendingCalls - 1, currentCustomer: action.payload, lastError : undefined };

        case CREATE_CUSTOMER:
            return { ...state, pendingCalls: state.pendingCalls + 1 };

        case CREATED_CUSTOMER:
            return { ...state, pendingCalls: state.pendingCalls - 1, currentCustomer: action.payload, lastError : undefined };

        case GET_LANGUAGES:
            return { ...state, pendingCalls: state.pendingCalls + 1  };

        case RETRIEVED_LANGUAGES:
            return { ...state, pendingCalls: state.pendingCalls - 1, languages: action.payload , lastError : undefined};

        case GET_LANGUAGE:
            return { ...state, pendingCalls: state.pendingCalls + 1 };

        case RETRIEVED_LANGUAGE:
            return { ...state, pendingCalls: state.pendingCalls - 1, currentLanguage: action.payload , lastError : undefined};

        case DOWNLOAD_TRANSLATIONS:
            return { ...state, pendingCalls: state.pendingCalls + 1, lastError : undefined};

        case DOWNLOADED_TRANSLATIONS:
            return { ...state, pendingCalls: state.pendingCalls - 1, lastError : undefined};

        case SAVE_LANGUAGE:
            return { ...state, pendingCalls: state.pendingCalls + 1 };

        case SAVED_LANGUAGE:
            return { ...state, pendingCalls: state.pendingCalls - 1, currentLanguage: action.payload, lastError : undefined };

        case CREATE_LANGUAGE:
            return { ...state, pendingCalls: state.pendingCalls + 1};

        case CREATED_LANGUAGE:
            return { ...state, pendingCalls: state.pendingCalls - 1 , currentLanguage: action.payload, lastError : undefined};

        case SAVE_TRANSLATION_KEYS:
            console.log("saving keys");
            return { ...state, pendingCalls: state.pendingCalls + 1};

        case SAVED_TRANSLATION_KEYS:
            console.log("Saved keys");
            return { ...state, pendingCalls: state.pendingCalls - 1 , lastError : undefined};

        case API_CALL_FAILED:
            console.error("API_CALL_FAILED: "+action.payload.message);
            return { ...state, pendingCalls: state.pendingCalls - 1, lastError: action.payload.message };

        case PRIVATE_CORE_LOGIN:
            return { ...state, pendingCalls: state.pendingCalls + 1 };

        case PRIVATE_CORE_LOGOUT:
            const updateState = {...state};
            delete updateState.currentCustomer;
            if(typeof action.payload.customerId === "string")
                delete updateState.privateCoreJwt[action.payload.customerId];
            return updateState;

        case PRIVATE_CORE_LOGGED_IN:
            const addPrivateCoreJwts = {[action.payload.customer.id]: action.payload.jwt};
            const privateCoreJwt = Object.assign({}, state.privateCoreJwt, addPrivateCoreJwts);
            return { ...state, pendingCalls: state.pendingCalls - 1, privateCoreJwt, lastError : undefined };

        case GET_PREDEFINED_TEXTS:
            if(state.currentCustomer && action.payload.id === state.currentCustomer.id) {
                return { ...state, pendingCalls: state.pendingCalls + 1};
            }
            else {
                console.warn("Application seems out of balance. Skipping call.");
                return state;
            }

        case RETRIEVED_PREDEFINED_TEXTS:
            const addPredefinedTexts = {[action.payload.customer.id]: action.payload.predefinedTexts};
            const predefinedTexts = Object.assign({}, state.predefinedTexts, addPredefinedTexts);
            return { ...state, pendingCalls: state.pendingCalls - 1, predefinedTexts };

        case SAVE_PREDEFINED_TEXT:
            if(action.payload.mode === CREATE_MODE) {
                return { ...state, pendingCalls: state.pendingCalls + 1 };
            }
            else if(action.payload.mode === EDIT_MODE) {
                return { ...state, pendingCalls: state.pendingCalls + 1 };
            }
            else if(action.payload.mode === DELETE_MODE) {
                return { ...state, pendingCalls: state.pendingCalls + 1 };
            }

            return state;

        case SAVED_PREDEFINED_TEXT:
            return { ...state, pendingCalls: state.pendingCalls - 1};

        case GET_PROPERTY_DEFINITIONS:
            if(state.currentCustomer && action.payload.id === state.currentCustomer.id) {
                return { ...state, pendingCalls: state.pendingCalls + 1 };
            }
            else {
                console.warn("Application seems out of balance. Skipping call.");
                return state;
            }

        case RETRIEVED_PROPERTY_DEFINITIONS:
            const addPropertyDefinitions = {[action.payload.customer.id]: action.payload.propertyDefinitions};
            const propertyDefinitions = Object.assign({}, state.propertyDefinitions, addPropertyDefinitions);
            return { ...state, pendingCalls: state.pendingCalls - 1, propertyDefinitions };

        default:
            return state;
    }
};

const reducers = (state, action) => {
    return addLastAction(actionToState(state, action), action)
};

export default reducers;



// WEBPACK FOOTER //
// ./src/redux/reducers.js